<template>
  <div class="about-container">
    <!-- Fondo animado de estrellas -->
    <div class="stars-background">
      <div v-for="n in 50" :key="n" class="star" :style="getStarStyle()"></div>
    </div>
    
    <!-- Contenido principal -->
    <div class="content-wrapper">
      <!-- Header con animación de nave espacial -->
      <div class="header-section">
        <div class="spaceship">
          <div class="spaceship-body"></div>
          <div class="spaceship-wing left"></div>
          <div class="spaceship-wing right"></div>
          <div class="spaceship-flame"></div>
        </div>
        <h1 class="main-title">{{ title }}</h1>
        <p class="subtitle">{{ subtitle }}</p>
      </div>

      <!-- Sección de información -->
      <div class="info-section">
        <div class="planet-container">
          <div class="planet"></div>
          <div class="planet-ring"></div>
        </div>
        
        <div class="text-content">
          <h2>Nuestra Misión</h2>
          <p>{{ mission }}</p>
          
          <h2>Nuestra Visión</h2>
          <p>{{ vision }}</p>
          
          <div class="stats-container">
            <div v-for="stat in stats" :key="stat.label" class="stat-card">
              <div class="stat-icon">🚀</div>
              <div class="stat-number">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección del equipo -->
      <div class="team-section">
        <h2>Nuestro Equipo Espacial</h2>
        <div class="astronauts-container">
          <div v-for="member in team" :key="member.id" class="astronaut-card">
            <div class="astronaut-helmet"></div>
            <h3>{{ member.name }}</h3>
            <p class="role">{{ member.role }}</p>
            <p class="description">{{ member.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpaceAbout',
  data() {
    return {
      title: 'Exploración Espacial',
      subtitle: 'Navegando hacia el futuro del universo digital',
      mission: 'Crear experiencias digitales extraordinarias que conecten a las personas con la inmensidad del cosmos tecnológico, impulsando la innovación más allá de los límites terrestres.',
      vision: 'Ser pioneros en el desarrollo de soluciones que trasciendan las fronteras convencionales, explorando nuevos horizontes en el vasto espacio de las posibilidades digitales.',
      stats: [
        { label: 'Proyectos Lanzados', value: '150+' },
        { label: 'Años de Experiencia', value: '8' },
        { label: 'Planetas Explorados', value: '∞' },
        { label: 'Clientes Satisfechos', value: '500+' }
      ],
      team: [
        {
          id: 1,
          name: 'Alex Nova',
          role: 'Comandante Frontend',
          description: 'Experto en navegación de interfaces espaciales'
        },
        {
          id: 2,
          name: 'Luna García',
          role: 'Ingeniera de UX',
          description: 'Diseñadora de experiencias intergalácticas'
        },
        {
          id: 3,
          name: 'Cosmos Rivera',
          role: 'Arquitecto Backend',
          description: 'Constructor de sistemas estelares'
        }
      ]
    }
  },
  methods: {
    getStarStyle() {
      return {
        left: Math.random() * 100 + '%',
        top: Math.random() * 100 + '%',
        animationDelay: Math.random() * 3 + 's',
        animationDuration: (Math.random() * 3 + 2) + 's'
      }
    }
  }
}
</script>

<style scoped>
.about-container {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(135deg, #003366 0%, #336699 100%);
  overflow-x: hidden;
  font-family: 'Arial', sans-serif;
  color: white;
}

/* Fondo de estrellas animado */
.stars-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.star {
  position: absolute;
  width: 2px;
  height: 2px;
  background: white;
  border-radius: 50%;
  animation: twinkle infinite ease-in-out;
}

@keyframes twinkle {
  0%, 100% { opacity: 0; }
  50% { opacity: 1; }
}

/* Contenido principal */
.content-wrapper {
  position: relative;
  z-index: 2;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

/* Header section */
.header-section {
  text-align: center;
  padding: 4rem 0;
  position: relative;
}

.spaceship {
  position: relative;
  display: inline-block;
  margin-bottom: 2rem;
  animation: float 3s ease-in-out infinite;
}

.spaceship-body {
  width: 60px;
  height: 30px;
  background: linear-gradient(45deg, #336699, #66ccff);
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  position: relative;
}

.spaceship-wing {
  position: absolute;
  width: 20px;
  height: 15px;
  background: #336699;
  top: 50%;
  transform: translateY(-50%);
}

.spaceship-wing.left {
  left: -15px;
  border-radius: 50% 0 0 50%;
}

.spaceship-wing.right {
  right: -15px;
  border-radius: 0 50% 50% 0;
}

.spaceship-flame {
  position: absolute;
  width: 8px;
  height: 20px;
  background: linear-gradient(to top, #ff6600, #ffcc00);
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  border-radius: 0 0 50% 50%;
  animation: flame 0.5s ease-in-out infinite alternate;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes flame {
  0% { height: 15px; }
  100% { height: 25px; }
}

.main-title {
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 0 0 20px rgba(102, 204, 255, 0.5);
}

.subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
  margin-bottom: 2rem;
}

/* Info section */
.info-section {
  display: flex;
  align-items: center;
  gap: 4rem;
  margin: 4rem 0;
  flex-wrap: wrap;
}

.planet-container {
  position: relative;
  flex: 0 0 300px;
  height: 300px;
}

.planet {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle at 30% 30%, #66ccff, #003366);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: rotate 20s linear infinite;
}

.planet-ring {
  width: 280px;
  height: 280px;
  border: 3px solid rgba(102, 204, 255, 0.3);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(60deg);
  animation: ring-rotate 15s linear infinite;
}

@keyframes rotate {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes ring-rotate {
  0% { transform: translate(-50%, -50%) rotateX(60deg) rotateZ(0deg); }
  100% { transform: translate(-50%, -50%) rotateX(60deg) rotateZ(360deg); }
}

.text-content {
  flex: 1;
  min-width: 300px;
}

.text-content h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #66ccff;
  text-shadow: 0 0 10px rgba(102, 204, 255, 0.3);
}

.text-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;
}

/* Stats */
.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1.5rem;
  margin: 3rem 0;
}

.stat-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 1.5rem;
  text-align: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(102, 204, 255, 0.2);
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  color: #66ccff;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.8;
}

/* Team section */
.team-section {
  margin: 4rem 0;
  text-align: center;
}

.team-section h2 {
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #66ccff;
  text-shadow: 0 0 15px rgba(102, 204, 255, 0.3);
}

.astronauts-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.astronaut-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 2rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(102, 204, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.astronaut-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(102, 204, 255, 0.2);
}

.astronaut-helmet {
  width: 80px;
  height: 80px;
  background: linear-gradient(45deg, #66ccff, #336699);
  border-radius: 50%;
  margin: 0 auto 1rem;
  position: relative;
  border: 3px solid rgba(255, 255, 255, 0.3);
}

.astronaut-helmet::after {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.astronaut-card h3 {
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: #66ccff;
}

.role {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  opacity: 0.8;
}

.description {
  font-size: 0.9rem;
  opacity: 0.7;
  line-height: 1.5;
}

/* Responsive */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 1rem;
  }
  
  .main-title {
    font-size: 2.5rem;
  }
  
  .info-section {
    flex-direction: column;
    text-align: center;
  }
  
  .planet-container {
    flex: none;
  }
  
  .stats-container {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .astronauts-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 2rem;
  }
  
  .stats-container {
    grid-template-columns: 1fr;
  }
}
</style>
